import { Insight } from './insight';
import {
  INSIGHTS_DATA,
  INSIGHTS_HEADLINE,
  MAIN_INSIGHTS_TITLE,
  INSIGHTS_TEXT_CONTENT,
} from './insights-data';
import {
  Container,
  Title,
  Text,
  MainInsightsTitle,
} from './insights-section.styles';

export const InsightsSection: React.FC = () => (
  <Container id="insights-section">
    <Title size="xxlarge">{INSIGHTS_HEADLINE}</Title>
    <Text size="xlarge">{INSIGHTS_TEXT_CONTENT}</Text>
    <MainInsightsTitle size="small">{MAIN_INSIGHTS_TITLE}</MainInsightsTitle>
    {INSIGHTS_DATA.map((item) => (
      <Insight text={item} key={item} />
    ))}
  </Container>
);
